import { render, staticRenderFns } from "./CpnyPopupTable.vue?vue&type=template&id=572b2d62&"
import script from "./CpnyPopupTable.vue?vue&type=script&lang=js&"
export * from "./CpnyPopupTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports